import { PhosphorGearAnchor } from "components/Atoms/PhosphorIconAnchor";
import { useValidateAlwaysFails, } from "formvalidation/hooks";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";


const NoBankAccountsWarning = () => {
  const validation = useValidateAlwaysFails({ key: "bankAccount", title: RESX.BankAccount.resxBankAccount });

  return <div ref={validation.ref} className="message ui red flex margin-bottom gap" style={{ padding: 4 }}>
    <div className="grow1 padding">
      {RESX.BankAccount.NoBankAccountWarning}
    </div>
    <div>
      <PhosphorGearAnchor
        href={routes.bankAccount_List().absolute}
        layout="in-square"
        backgroundColor="light"
        padding="large"
      />
    </div>
  </div>
}

export default NoBankAccountsWarning;